<mat-sidenav-container
  hasBackdrop="true"
  class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0"
>
  <div class="mx-auto flex w-full flex-wrap p-4">
    <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
      <div>
        <div class="flex items-center gap-1">
          <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
            <button mat-icon-button color="primary">
              <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
            </button>
          </div>
          <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
            <div class="p-4">
              <p>Zonas donde atiendes clientes. Agrupa direcciones
                de clientes y rutas que los visitan. Úsalo para
                planear cobertura y asignar rutas por zona.
              </p>
            </div>
          </mat-menu>
          <h2 class="text-xl font-semibold leading-8 tracking-tight">
            Territorios
          </h2>
        </div>
        <div class="text-sm text-secondary font-medium tracking-tight">
          Permite monitorear...
        </div>
      </div>
      <!-- Header -->
      <div
        class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between"
      >
        <div class="flex shrink-0">
          <app-status-filters [selectedStatuses]="selectedStatuses" [showStatus]="[1,0]" [typeFilter]="'master'"
            (selectionFilterApply)="findAllWithCount()">
          </app-status-filters>
          <!-- Title -->
          <!--<div class="text-3xl font-extrabold tracking-tight">Territorios</div> -->
        </div>
        <!-- Actions -->
        <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
          <button class="ml-3 hidden sm:inline-flex" mat-flat-button [color]="'primary'" (click)="onExportButtonPressed()" matTooltip="Exportar">
            <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:document-arrow-down'"></mat-icon>
            <span class="ml-2">Exportar</span>
          </button>
          
          <!-- Add button (only icon) -->
          <button
            mat-icon-button
            color="primary"
            (click)="openCreateModal()"
            matTooltip="Nuevo Registro"
          >
            <mat-icon svgIcon="heroicons_outline:plus"></mat-icon>
          </button>
        </div>
      </div>
    </div>
   <div class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
      <!-- Main Content (Table and Paginator) -->
      <div class="pt-1 mx-6">
        <!-- Tabla -->
        <div class="flex flex-col flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 270px)">
          <!-- Header -->
          <div class="overflow-auto flex-1 dark:bg-gray-900">
            <table class="w-full bg-transparent"
            mat-table
            [dataSource]="dataSource"
            matSort
            [trackBy]="trackByFn"
          >
            <!-- Nombre -->
            <ng-container matColumnDef="name">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
              >
                Nombre
              </th>
              <td mat-cell *matCellDef="let route" class="text-sm uppercase leading-tight">
                <div *ngIf="getCode(route) as code">
                  <b class="f-10">{{ code }}</b>
                </div>
                {{ route.name }}
              </td>
            </ng-container>

            <!-- Compañía -->
            <ng-container matColumnDef="company">
              <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
              >
                Compañía
              </th>
              <td mat-cell *matCellDef="let route" class="text-sm uppercase">
                <!-- <div><b>{{ route.company.id }}</b></div> -->
                <div>{{ route.company.name }}</div>
              </td>
            </ng-container>

            <!-- Estado -->
            <ng-container matColumnDef="statusId">
              <th mat-header-cell *matHeaderCellDef class="px-6 text-left">
                Estado
              </th>
              <td mat-cell *matCellDef="let route" class="px-6 text-left">
                <mat-slide-toggle
                  class="custom-slide-toggle primary"
                  [checked]="route.statusId == 1"
                  [(ngModel)]="route.statusId"
                  [color]="'success'"
                  (ngModelChange)="onStatusChange($event, route)"
                >
                </mat-slide-toggle>
              </td>
            </ng-container>

            <!-- Acciones -->
            <ng-container matColumnDef="actions">
              <th
                mat-header-cell
                *matHeaderCellDef
                class="px-6 py-3 text-left"
              ></th>
              <td mat-cell *matCellDef="let route" class="px-6 py-3 text-left">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="actionMenu"
                  matTooltip="Acciones"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #actionMenu="matMenu">
                  <button mat-menu-item (click)="openEditModal(route)">
                    <mat-icon
                      svgIcon="heroicons_outline:pencil-square"
                    ></mat-icon>
                    <span>Editar Registro</span>
                  </button>
                    <!-- <button mat-menu-item (click)="openItineraryModal(route)">
                    <mat-icon svgIcon="heroicons_outline:calendar-days"></mat-icon>
                    <span>Asignar Itinerario</span>
                  </button> -->
                  <button mat-menu-item (click)="openDeleteDialog(route)">
                    <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                    <span>Eliminar Registro</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <!-- Header Row -->
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns"
              class="sticky top-0 z-10  bg-white dark:bg-gray-900"
            ></tr>

            <!-- Fila principal -->
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              class="border-b"
            ></tr>
            </table>
          </div>
        </div>

        <!-- Paginación -->
        <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
          <mat-paginator
            class="z-10"
            [pageSizeOptions]="[50, 100, 150, 200]"
            showFirstLastButtons
            [length]="totalItems"
            [pageSize]="pageSize"
            (page)="onPageChange($event)"
          ></mat-paginator>
        </div>
      </div>
    </div>

    <!-- Modales -->
    <ng-template #addModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Nuevo Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #createForm="ngForm">
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Código Externo</mat-label>
            <input
              matInput
              [(ngModel)]="currentCreateRoute.code"
              name="code"
              required
            />
          </mat-form-field>
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Nombre</mat-label>
            <input
              matInput
              [(ngModel)]="currentCreateRoute.name"
              name="name"
              required
            />
          </mat-form-field>

          <!-- Select Compañía -->
          <div class="col-span-1">
            <label>Compañía</label>
            <ng-select
              [(ngModel)]="currentCreateRoute.companyId"
              [items]="companyList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Seleccione una compañía"
              name="companyId"
              required
              [appendTo]="'body'"
            >
            </ng-select>
          </div>

          <!-- <div class="col-span-1">
            <label>Área de Rutas</label>
            <ng-select
              [(ngModel)]="currentCreateRoute.routeareaId"
              [items]="routeAreaList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Seleccionar un area"
              name="routeareaId"
              required
            >
            </ng-select>
          </div>
          <div class="col-span-1">
            <label>Grupo de Rutas</label>
            <ng-select
              [(ngModel)]="currentCreateRoute.routegroupId"
              [items]="routeGroupList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Seleccionar un grupo"
              name="routegroupId"
              required
            >
            </ng-select>
          </div> -->
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button
          mat-raised-button
          color="primary"
          (click)="createRoute()"
          [disabled]="!createForm.valid"
        >
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Editar -->
    <ng-template #editModal>
      <h2 mat-dialog-title class="text-lg font-bold mb-1">Editar Registro</h2>
      <mat-dialog-content class="modal-content">
        <form #editForm="ngForm">
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Código Externo</mat-label>
            <input
              matInput
              [(ngModel)]="currentUpdateRoute.externalKeys.code"
              name="code"
              disabled
            />
          </mat-form-field>
          <mat-form-field appearance="fill" class="modal-input">
            <mat-label>Nombre</mat-label>
            <input
              matInput
              [(ngModel)]="currentUpdateRoute.name"
              name="name"
              required
            />
          </mat-form-field>

          <!-- Select Compañía -->
          <div class="col-span-1">
            <label>Compañía</label>
            <ng-select
              [(ngModel)]="currentUpdateRoute.company._id"
              [items]="companyList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Seleccionar"
              name="companyId"
              required
              [appendTo]="'body'"
            >
            </ng-select>
          </div>

          <!-- <div class="col-span-1">
            <label>Área de Rutas</label>
            <ng-select
              [(ngModel)]="currentUpdateRoute.routearea._id"
              [items]="routeAreaList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Seleccionar un area"
              name="routeareaId"
              required
            >
            </ng-select>
          </div>
          <div class="col-span-1">
            <label>Grupo de Rutas</label>
            <ng-select
              [(ngModel)]="currentUpdateRoute.routegroup._id"
              [items]="routeGroupList"
              bindLabel="name"
              bindValue="_id"
              [searchable]="true"
              placeholder="Seleccionar un grupo"
              name="routegroupId"
              required
            >
            </ng-select>
          </div> -->
        </form>
      </mat-dialog-content>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">Cancelar</button>
        <button
          mat-raised-button
          color="primary"
          (click)="updateRoute(currentUpdateRoute._id)"
          [disabled]="!editForm.valid"
        >
          Guardar
        </button>
      </mat-dialog-actions>
    </ng-template>

    <!-- Modal Eliminar -->
    <ng-template #deleteDialog let-data>
      <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
          <mat-icon
            svgIcon="heroicons_outline:exclamation-triangle"
            class="text-red-500 ml-4 mt-6"
            style="font-size: 32px"
          ></mat-icon>
        </div>
        <div class="grid">
          <h2 mat-dialog-title class="text-lg font-bold mb-1">
            Confirmar eliminación
          </h2>
          <mat-dialog-content class="modal-content mt-0">
            <p>¿Está seguro que desea eliminar el registro?</p>
          </mat-dialog-content>
        </div>
      </div>
      <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
          Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
          Eliminar
        </button>
      </mat-dialog-actions>
    </ng-template>
  </div>


           <!-- Modal Itinerario  -->
           <ng-template #addModalItinerary>
            <mat-dialog-content class="modal-content">
           
             <div class="flex justify-end mb-2">
               <button
                 mat-button
                 (click)="openAddItineraryModal()"
                 matTooltip="Asignar Itinerario"
               >
                 <mat-icon svgIcon="heroicons_outline:plus-circle"></mat-icon>
                 <span></span>
               </button>
             </div>
             <!-- Tabla de Itinrario -->
             <div>
               <table
                 mat-table
                 [dataSource]="currentUpdateRoute.itinerary"
                 class="min-w-500 overflow-y-visible mat-elevation-z"
               >
               <ng-container matColumnDef="days">
                 <th mat-header-cell *matHeaderCellDef>Días</th>
                 <td mat-cell *matCellDef="let element">
                   {{ getDayNames(element.days) }}
                 </td>
               </ng-container>
       
                 <ng-container matColumnDef="action">
                   <th mat-header-cell *matHeaderCellDef>Accion</th>
                   <td mat-cell *matCellDef="let element">
                     {{ element.action }}
                   </td>
                 </ng-container>
       
                 <ng-container matColumnDef="status">
                   <th mat-header-cell *matHeaderCellDef>Estado</th>
                   <td mat-cell *matCellDef="let element">
                     {{ element.statusId }}
                   </td>
                 </ng-container>
       
                 <ng-container matColumnDef="actions">
                   <th mat-header-cell *matHeaderCellDef></th>
                   <td mat-cell *matCellDef="let element">
                     <div class="button-container">
                       <button mat-icon-button (click)="openDeleteItinerary(element)">
                         <mat-icon svgIcon="heroicons_outline:trash"></mat-icon>
                       </button>
                       <button mat-icon-button (click)="openAddItineraryModal(element)">
                         <mat-icon
                           svgIcon="heroicons_outline:pencil-square"
                         ></mat-icon>
                       </button>
                     </div>
                   </td>
                 </ng-container>
       
                 <tr mat-header-row *matHeaderRowDef="displayedColumnsI"></tr>
                 <tr mat-row *matRowDef="let row; columns: displayedColumnsI"></tr>
               </table>
                  <!-- Paginación -->
             </div>
           
       </mat-dialog-content>
           <mat-dialog-actions class="modal-actions flex justify-end">
             <button mat-button mat-dialog-close class="align-left">Cancelar</button>
           </mat-dialog-actions>
         </ng-template>
         
  <!-- Filtros -->
 <app-filter (onFilterEvent)="findAllWithCount()" (onCleanEvent)="clearFilters()" (onPanelOpened)="onFilterPanelOpened()">
    <app-configuration-filters [form]="form" [company]="true" [loadData]="loadFiltersData"></app-configuration-filters>
     </app-filter>
</mat-sidenav-container>
